import { apiFetch } from "@/lib/api";
import type { Proposal, ProposalListResponse } from "@/lib/proposalsApi";

export const fetchLegacyProposals = async (params: {
  page: number;
  size: number;
  search?: string;
  sortField?: string | null;
  sortOrder?: string | null;
  status?: string | null;
  priority?: string | null;
  ownerId?: string | null;
}): Promise<ProposalListResponse> => {
  const query = new URLSearchParams();
  query.set("page", String(params.page));
  query.set("size", String(params.size));
  if (params.search) query.set("search", params.search);
  if (params.sortField) query.set("sortField", params.sortField);
  if (params.sortOrder) query.set("sortOrder", params.sortOrder);
  if (params.status) query.set("status", params.status);
  if (params.priority) query.set("priority", params.priority);
  if (params.ownerId) query.set("owner_id", params.ownerId);
  const payload = await apiFetch<ProposalListResponse | null>(`/legacy-proposals?${query.toString()}`);
  return payload ?? { items: [], total: 0 };
};

export const getLegacyProposal = async (id: string): Promise<Proposal> => {
  return apiFetch<Proposal>(`/legacy-proposals/${id}`);
};

export const createLegacyProposal = async (data: Partial<Proposal>): Promise<Proposal> => {
  return apiFetch<Proposal>("/legacy-proposals/import", {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const updateLegacyProposalOwner = async (id: string, ownerId: string): Promise<Proposal> => {
  return apiFetch<Proposal>(`/legacy-proposals/${id}/owner`, {
    method: "PUT",
    body: JSON.stringify({ owner_id: ownerId }),
  });
};

export const deleteLegacyProposal = async (id: string): Promise<void> => {
  await apiFetch<void>(`/legacy-proposals/${id}`, { method: "DELETE" });
};

export const deleteAllLegacyProposals = async (): Promise<void> => {
  await apiFetch<void>("/legacy-proposals", { method: "DELETE" });
};
